import { ID } from '@datorama/akita';
import { IEntity } from '../interfaces/models';
import { IRole } from './role.model';
import { IUser } from './user.model';

export interface IPermission extends IEntity {
  userName: string;
  userRole: IRole;
}

export class Permission implements IPermission {
  id: ID;
  active: boolean;
  clientId: ID;
  userName: string;
  roleId: ID;
  roleName: string;
  role?: IRole;
  createdAt?: Date;
  modifiedAt?: Date;
  createdBy?: string;
  modifiedBy?: string;
  href?: string;
  userRole: IRole;

  constructor(
    user: IUser = {
      clientId: '',
      id: '',
      createdAt: new Date(),
      modifiedAt: new Date(),
      createdBy: '',
      modifiedBy: '',
      href: null,
      userName: '',
      roleId: '',
      roleName: '',
      active: false,
    }
  ) {
    const {
      id,
      clientId,
      createdAt,
      modifiedAt,
      createdBy,
      modifiedBy,
      href,
      userName,
      roleId,
      roleName,
      active,
    } = user;

    this.id = userName;
    this.userName = userName;
    this.roleName = roleName;
    this.active = active;
    this.clientId = clientId;
    this.createdAt = createdAt;
    this.modifiedAt = modifiedAt;
    this.createdBy = createdBy;
    this.modifiedBy = modifiedBy;
    this.href = href;
    this.roleId = roleId;
  }
}
